function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import TwoThirdsTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component";
import ReviewsCarousel from "segments/desktop/core-components/reviews-carousel/reviews-carousel";
import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import DefaultProps from "./default-props";
import { StyledParagraphAndCarouselReviewsDesktopComponent } from "./paragraph-and-carousel-reviews-component.scss";
import { ParagraphAndCarouselReviewsMobileComponent } from "./paragraph-and-carousel-reviews-mobile-component/paragraph-and-carousel-reviews-mobile-component";
const ParagraphAndCarouselReviewsDesktopComponent = (props)=>{
    const { carousel, removeQuoteSigns } = props, rest = _object_without_properties(props, [
        "carousel",
        "removeQuoteSigns"
    ]);
    return /*#__PURE__*/ _jsx(StyledParagraphAndCarouselReviewsDesktopComponent, {
        className: "paragraph-and-carousel-reviews-component",
        children: /*#__PURE__*/ _jsx(TwoThirdsTextAndAssetComponent, _object_spread_props(_object_spread({}, rest), {
            replaceAssetComponent: ReviewsCarousel,
            replaceAssetComponentProps: _object_spread_props(_object_spread({}, carousel), {
                removeQuoteSigns
            })
        }))
    });
};
const ParagraphAndCarouselReviewsComponent = withResponsiveHOC(ParagraphAndCarouselReviewsDesktopComponent, ParagraphAndCarouselReviewsMobileComponent);
ParagraphAndCarouselReviewsComponent.defaultProps = DefaultProps;
export default ParagraphAndCarouselReviewsComponent;
